import { configureStore } from "@reduxjs/toolkit";
import cartSlice from "../Features/Cart/cartSlice";
import wishListSlice from "../Features/Wishlist/wishListSlice";
import posReducer from '../Slice/PosSlice';  
import authSlice from '../Slice/Auth.Slice'
import OrderSlice from '../Slice/Order.Slice'
import BuySlice from '../Slice/Buy.Slice'
import paymentSlice from '../Slice/Payment.Slice'



const store = configureStore({
  reducer: {
    cart: cartSlice,
    wishlist: wishListSlice,
    pos: posReducer,
    auth: authSlice,
    orders: OrderSlice,
    BuyOrder:BuySlice,
    payment:paymentSlice
  },
});

// ✅ Export RootState and AppDispatch types for use throughout your app
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;


export default store;
